import { IonItem, IonLabel, IonToggle } from "@ionic/react";
import React, { useCallback } from "react";
import { useOfflineStore } from "../store/offline-mode";
import { useHistory } from "react-router";
import { useWorkOrderStore } from "../store/wo-order";
import useSyncOfflineUpdates from "../hooks/offline/useSyncOfflineUpdates";
import { useUserStore } from "../store/user";
import { useSettingsStore } from "../store/settings";
import { useEquipmentStore } from "../store/equipment";

const OfflineToggle: React.FC = () => {
  const isOffline = useOfflineStore((state) => state.isOffline);
  const toggleOffline = useOfflineStore((state) => state.toggleOffline);
  const resetWoStore = useWorkOrderStore((state) => state.reset);
  const resetEquipmentStore = useEquipmentStore((state) => state.reset);
  const resetUserStore = useUserStore((state) => state.reset);
  const resetSettingStore = useSettingsStore((state) => state.reset);
  const history = useHistory();
  const { syncOfflineUpdates } = useSyncOfflineUpdates();

  const handleOfflineToggle = useCallback(async () => {
    toggleOffline();
    //when offline is toggled on
    if (!isOffline) history.push("/WorkOrders/true");
    //when offline is toggled off
    if (isOffline) {
      await syncOfflineUpdates(); //start syncing
      //reset storage
      resetWoStore();
      resetEquipmentStore();
      resetUserStore();
      resetSettingStore();
      history.push("/offline/upload-data");
    }
  }, [
    history,
    isOffline,
    resetEquipmentStore,
    resetSettingStore,
    resetUserStore,
    resetWoStore,
    syncOfflineUpdates,
    toggleOffline,
  ]);

  return (
    <IonItem>
      <div style={{ width: "100%", paddingTop: 5 }}>
        <IonLabel>
          <h3 style={{ fontSize: "12px" }}>
            App is currently in offline mode. This means work orders will be
            loaded from cache.
          </h3>
        </IonLabel>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <IonLabel>Is offline</IonLabel>
          <IonToggle checked={isOffline} onClick={handleOfflineToggle}>
            Checked Toggle
          </IonToggle>
        </div>
      </div>
    </IonItem>
  );
};

export default OfflineToggle;
